import { getProfileId } from "../../../utils/validationUtils";
import { getApiInstance } from "../../AppService";
import {
  ADD_NEW_PRODUCT_CATALOG_PARTNER,
  CATALOG_PARTNER_ADD_AUTH,
  CATALOG_PARTNER_ADD_BULK_AUTH,
  CATALOG_PARTNER_GET_AUTH,
  CHECK_CATALOG_PARTNER_SETTING,
  COPY_MASTER_BRANCH_AUTH,
  GET_BUYMORE_AUTH_WAREHOUSE_INFO,
  GET_BUYMORE_GET_TOKEN,
  GET_BUYMORE_PRODUCT_DETAILS,
  GET_UNICOM_INVENTORY_SNAPSHOT,
  GET_UNICOM_ITEM_DETAILS,
  GET_UNICOMMERCE_FACILITY_INFO,
  UPDATE_PRODUCT_CATALOG_PARTNER,
} from "../../constant";

// Add Catalog Partner Auth
export const catalogPartnerAddAuth = async (data) => {
  const profileId = getProfileId();
  try {
    const instance = getApiInstance({
      header: {
        businessId: data?.businessId,
      },
    });

    const response = await instance.post(CATALOG_PARTNER_ADD_AUTH, {
      ...data,
      profileId,
    });
    return response.data;
  } catch (error) {
    console.log("AUTH_ERR", error?.response?.data);
    return error?.response?.data;
  }
};

// Add Bulk Catalog Partner Auth
export const catalogPartnerBulkAddAuth = async (data) => {
  const profileId = getProfileId();
  try {
    const instance = getApiInstance({
      header: {
        businessId: data?.businessId,
      },
    });

    const response = await instance.post(CATALOG_PARTNER_ADD_BULK_AUTH, {
      ...data,
      profileId,
    });
    return response.data;
  } catch (error) {
    console.log("AUTH_ERR", error?.response?.data);
    return error?.response?.data;
  }
};

// Get Catalog Partner Auth
export const catalogPartnerGetAuth = async (data) => {
  try {
    const instance = getApiInstance({
      header: {
        businessId: data?.businessId,
      },
    });

    const response = await instance.get(CATALOG_PARTNER_GET_AUTH, {
      params: {
        catalogPartner: data?.catalogPartner,
      },
    });

    return response.data;
  } catch (error) {
    console.log("GET_AUTH_ERR", error?.response?.data);
    return error?.response?.data;
  }
};

// Get Catalog Partner Auth
export const getUnicomerceFacilityInfo = async (data, businessId) => {
  try {
    const instance = getApiInstance({
      header: {
        businessId: businessId,
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });

    const response = await instance.post(GET_UNICOMMERCE_FACILITY_INFO, data);

    return response.data;
  } catch (error) {
    console.log("GET_AUTH_ERR", error?.response?.data);
    return error?.response?.data;
  }
};

// Get Unicommerce Product Details
export const getCatalogPartnerProductInfo = async (data) => {
  const profileId = getProfileId();
  try {
    const instance = getApiInstance({
      header: {
        businessId: data?.businessId,
      },
    });

    const response = await instance.get(GET_UNICOM_ITEM_DETAILS, {
      params: {
        catalogPartner: data?.catelogPartner,
        skuCode: data?.skuCode,
      },
    });
    return response.data;
  } catch (error) {
    console.log("getCatalogPartnerProductInfo_ERR", error?.response?.data);
    return error?.response?.data;
  }
};

// Add New Product Catalog Partner
export const addNewProductCatalogPartnerApi = async (data) => {
  try {
    const instance = getApiInstance({
      header: {
        businessId: data?.businessId,
      },
    });
    const response = await instance.post(ADD_NEW_PRODUCT_CATALOG_PARTNER, data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

// Upload Product Catalog Partner
export const uploadProductCatalogPartnerApi = async (data) => {
  try {
    const instance = getApiInstance();
    const response = await instance.post(UPDATE_PRODUCT_CATALOG_PARTNER, data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

// Check whether the catalog partner is linked
export const checkCatalogPartnerSettingApi = async (businessId) => {
  try {
    const instance = getApiInstance({
      header: {
        businessId: businessId,
      },
    });
    const response = await instance.get(CHECK_CATALOG_PARTNER_SETTING);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

// Copy auth from main branch to subbranch
export const copyMasterBranchAuthApi = async (data) => {
  try {
    const instance = getApiInstance({
      header: {
        mainBranchBusinessId: data?.mainBranchId,
      },
    });
    const response = await instance.get(COPY_MASTER_BRANCH_AUTH, {
      params: {
        catalogPartner: data?.catalogPartner,
        subBranchBusinessId: data?.subBranchId,
      },
    });
    return response.data;
  } catch (error) {
    console.log(error);
    return error?.response?.data;
  }
};

// Get Unicommerce Inventory Snapshot
export const getUnicomInventoryApi = async (postData) => {
  try {
    const instance = getApiInstance({
      header: {
        facility: postData?.facilityCode,
        businessId: postData?.businessId,
      },
    });

    const response = await instance.post(
      GET_UNICOM_INVENTORY_SNAPSHOT + `?catalogPartner=unicommerce`,
      postData?.skuList || []
    );

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

// -------- BuyMore --------

// Get BuyMore Auth and Warehouse Info
export const getBuyMoreAuthAndWareHouseApi = async (data, businessId) => {
  try {
    const instance = getApiInstance({
      header: {
        businessId: businessId,
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });

    const response = await instance.get(GET_BUYMORE_AUTH_WAREHOUSE_INFO, data);

    return response.data;
  } catch (error) {
    console.log("GET_AUTH_ERR", error?.response?.data);
    return error?.response?.data;
  }
};

// Get BuyMore Product Details
export const getBuyMoreProductDetailsApi = async (postData) => {
  try {
    const instance = getApiInstance({
      header: {
        businessId: postData?.businessId || "",
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });

    let params = {
      catalogPartner: "buymore",
      pageNumber: postData?.pageNumber || 1,
      pageSize: 500,
    };

    if (postData?.skuList?.length > 0) {
      params = { ...params, search: postData?.skuList?.join(",") };
    }

    const response = await instance.get(GET_BUYMORE_PRODUCT_DETAILS, {
      params,
    });

    return response.data;
  } catch (error) {
    console.log("GET_AUTH_ERR", error?.response?.data);
    return error?.response?.data;
  }
};
